import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";

/**
 * Sends user feedback of the given type.
 * Mutation input: `{ feedback: Record<string, string>; type: string }`
 */
export function useFeedback() {
  const $ = _c(2);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== apiFetcher) {
    t0 = {
      mutationFn: input => apiFetcher(`/api/v1/user/feedback/${input.type}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          feedback: input.feedback
        })
      })
    };
    $[0] = apiFetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
}